/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsThreadChartListItem
 */
export interface ControlcenterMelcoModelsThreadChartListItem {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChartListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChartListItem
     */
    file_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsThreadChartListItem
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsThreadChartListItem
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsThreadChartListItem
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsThreadChartListItem
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsThreadChartListItem
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChartListItem
     */
    signature?: string | null;
}

export function ControlcenterMelcoModelsThreadChartListItemFromJSON(json: any): ControlcenterMelcoModelsThreadChartListItem {
    return ControlcenterMelcoModelsThreadChartListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsThreadChartListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsThreadChartListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
    };
}

export function ControlcenterMelcoModelsThreadChartListItemToJSON(value?: ControlcenterMelcoModelsThreadChartListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'file_name': value.file_name,
        'version': value.version,
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'signature': value.signature,
    };
}


